import { Injectable } from '@angular/core'
import { AngularFireAuth } from '@angular/fire/compat/auth'
import firebase from 'firebase/compat/app'
import { Router } from '@angular/router'

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private userData: firebase.User

  constructor(
    public afAuth: AngularFireAuth, // Inject Firebase auth service
    public router: Router
  ) {    

    /* Saving user data as an object in localstorage if logged out than set to null */
    this.afAuth.authState.subscribe(user => {
      if (user) {        
        this.userData = user // Setting up user data in userData var
        localStorage.setItem('user', JSON.stringify(this.userData))
        JSON.parse(localStorage.getItem('user'))        
      } else {
        localStorage.setItem('user', null)
        JSON.parse(localStorage.getItem('user'))
      }
    })
  }

  /**
   * Faz o login com email e password
   * @param email
   * @param password
   * @returns
   */
  SignIn(email: string, password: string) {
    return this.afAuth
      .signInWithEmailAndPassword(email, password)
      .then(result => {
        // setar plano do usuário no storage
        this.setUserPlanCode().then(
          () => {return result}
        );
      })
      .catch(error => {
        throw 'Erro'
      })
  }

  /**
   * Autenticação com o Google
   * @returns
   */
  GoogleAuth(): Promise<any> {
    let provider = new firebase.auth.GoogleAuthProvider()
    // provider.addScope('profile');
    // provider.addScope('email');

    return new Promise((resolve, reject) => {
      return this.AuthLogin(provider).then((res: any) => {
        if (res) resolve(res)
      })
    })
  }

  /**
   * Autenticação com o Facebbok
   * @returns
   */
  FacebookAuth(): Promise<any> {
    let provider = new firebase.auth.FacebookAuthProvider()

    return new Promise((resolve, reject) => {
      return this.AuthLogin(provider).then((res: any) => {
        if (res) resolve(res)
      })
    })
  }

  /**
   * Autenticação com a conta Microsoft
   * @returns
   */
  MicrosoftAuth(): Promise<any> {
    let provider = new firebase.auth.OAuthProvider('microsoft.com')

    return new Promise((resolve, reject) => {
      return this.AuthLogin(provider).then((res: any) => {
        if (res) resolve(res)
      })
    })
  }

  /**
   * Logica para processar a autenticação de qualqeur provedor
   * @param provider
   * @returns
   */
  AuthLogin(provider: any) {
    return new Promise((resolve, reject) => {
      this.afAuth
        .signInWithPopup(provider)
        .then((res: any) => {
          resolve(res)
        })
        .catch(error => {
          console.log(error)
        })
    })
  }

  /**
   * Retorna o usuário presente no localstorage
   */
  get user(): firebase.User {
    return JSON.parse(localStorage.getItem('user'))
  }

  /**
   * Retorna o token que está no local storage
   */
  get token(): Promise<string> {
    return new Promise((resolve, reject) => {
      this.afAuth.currentUser
        .then(user => {
          resolve(user.getIdToken(true))
        })
        .catch(err => reject(err))
    })
  }

  /**
   * Retorna o UID do usuário
   */
  get uid(): Promise<string> {
    return new Promise((resolve, reject) => {
      this.afAuth.currentUser
        .then(user => {
          resolve(user.uid)
        })
        .catch(err => reject('Erro'))
    })
  }

  /**
   * Serviço que retorna se o usuário é pagante
   * @returns
   */
  isUserPro(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.afAuth.currentUser
        .then(async user => {
          let tk = await user.getIdTokenResult().then(data => {
            // retorna os claims do token
            let claims = data.claims

            // analisa se existe o array plano, com um tamanho maior do que 0
            if (claims.plano && claims.plano.length > 0) {

              // filtra o código 1 que é o plano mais básico
              let creditos = claims.plano.filter(f => {
                return f.codigo === 1
              })
              // verifica se o plano filtrado possui crédito maior do que 0 e retorna true ou false
              //resolve(creditos[0].creditos > 0)
              resolve(creditos?.[0]?.creditos > 0)
            } else {
              resolve(false)
            }
          })
        })
        .catch(err => reject('Erro'))
    })
  }


  /**
  * Salva o codigo do plano do usuário no storage.
  * @returns true or false
  */
  setUserPlanCode(): Promise<boolean> {

    return new Promise((resolve, reject) => {      

      // checa se já existe o plancode no storage
      let planos = JSON.parse(localStorage.getItem('userPlanCode'));
      if (planos) return;

      this.afAuth.currentUser
        .then(async user => {
          let tk = await user.getIdTokenResult();
          let claims = tk.claims;

          // Verifica se o usuário tem um plano e se o código do plano está presente
          if (claims.plano && claims.plano[0].codigo) {
            // Salva o código do plano no localStorage
            localStorage.setItem('userPlanCode', claims.plano[0].codigo);
            resolve(true); // Resolvendo a Promise com sucesso
          } else {
            // Se não há plano ou código de plano, resolva como falso
            localStorage.setItem('userPlanCode', '0');
            resolve(false);
          }
        })
        .catch(err => {
          console.error('Erro ao obter o token do usuário:', err);
          reject(false); // Rejeitando a Promise em caso de erro
        });
    });

  }

  /**
  * Retorna o usuário presente no localstorage
  */
  get getUserPlanCode() {
    return localStorage.getItem('userPlanCode');
  }

  /**
  * Checagem direta se o usuário tem plano baeado no localstorage
  */
 // plano gratuito
  get isUserPlanFree(): boolean {
    if (this.getUserPlanCode == '0' || this.getUserPlanCode == '' ) {
      return true;
    } else {
      return false;
    }
  } 
  
  // plano pro
  get isUserPlanPro(): boolean {
    if (this.getUserPlanCode == '1') {
      return true;
    } else {
      return false;
    }
  } 
  
  // plano escritório
  get isUserPlanEscritorio(): boolean {
    return (this.getUserPlanCode === '99' || this.getUserPlanCode === 'Trf5Gh87IuhJ87Am');    
  }

  get planosUsu(): Promise<any[]> {
    return new Promise((resolve, reject) => {
      this.afAuth.currentUser
        .then(async user => {
          let tk = await user.getIdTokenResult().then(data => {
            // retorna os claims do token
            let claims = data.claims

            // analisa se existe o array plano, com um tamanho maior do que 0
            if (claims.plano && claims.plano.length > 0) {
              // verifica se o plano filtrado possui crédito maior do que 0 e retorna true ou false
              resolve(claims.plano)
            } else {
              resolve([])
            }
          })
        })
        .catch(err => reject('Erro'))
    })
  }

  /**
   * Retorna verdadeiro ou falso para se o usuário esta logado
   * checando o local storage
   */
  get isLoggedIn(): boolean {
    const user = JSON.parse(localStorage.getItem('user'))
    return user !== null ? true : false
  }

  /*
   * Reenvia o email para validar o endereço
   */
  resendEmailVerification(): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!this.userData.emailVerified) {
        resolve(this.userData.sendEmailVerification())
      } else {
        reject('E-mail já validado!')
      }
    })
  }

  /**
   * Desloga o usuário
   * @returns
   */
  SignOut() {
    return this.afAuth.signOut().then(() => {
      localStorage.removeItem('user')
      this.router.navigate(['/login'])
    })
  }

  /**
   * Traduz uma mensagem de erro
   * @param error
   * @returns
   */
  private traduzirErro(error: any): string {
    switch (error.code) {
      case 'auth/user-disabled': {
        return 'Usuário não ativo.'
      }

      case 'auth/user-not-found': {
        return 'Usuário não encontrado'
      }

      case 'auth/wrong-password': {
        return 'Usuário ou senha inválido.'
      }

      case 'auth/user-mismatch': {
        return 'Usuário não encontrado'
      }

      case 'auth/too-many-requests': {
        return 'Identificadas muitas tentativas de acesso. Aguarde um pouco antes de tentar de novo'
      }

      default: {
        return 'Erro desconhecido. Tente novamente'
      }
    }
  }

  /**
   * Altera a senha do usuário
   * @param currentPass
   * @param newPass
   */
  changePassword(currentPass: string, newPass: string) {
    return new Promise((resolve, reject) => {
      let credential: firebase.auth.AuthCredential =
        firebase.auth.EmailAuthProvider.credential(
          this.userData.email,
          currentPass
        )

      this.userData
        .reauthenticateWithCredential(credential)
        .then(() => {
          this.userData
            .updatePassword(newPass)
            .then(() => {
              resolve('updated')
            })
            .catch(error => {
              reject(error)
            })
        })
        .catch(error => {
          reject(this.traduzirErro(error))
        })
    })
  }

  /**
   * Altera o email do usuário
   * @param currentPass
   * @param newPass
   */
  changeEmail(pass: string, newEmail: string) {
    return new Promise((resolve, reject) => {
      let credential: firebase.auth.AuthCredential =
        firebase.auth.EmailAuthProvider.credential(this.userData.email, pass)

      this.userData
        .reauthenticateWithCredential(credential)
        .then(() => {
          this.userData
            .verifyBeforeUpdateEmail(newEmail)
            .then(() => {
              resolve('updated')
            })
            .catch(error => {
              reject(error)
            })
        })
        .catch(error => {
          reject(this.traduzirErro(error))
        })
    })
  }

  /**
   * Reseta a senha do usuário, enviando um email
   * @param email
   * @returns
   */
  resetPassword(email: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.afAuth
        .sendPasswordResetEmail(email)
        .then(() => {
          resolve('enviado')
        })
        .catch(err => {
          reject(this.traduzirErro(err))
        })
    })
  }
}
